<template>
  <v-container class="cont">
    <vue-good-wizard
      :steps="steps"
      :onNext="nextClicked"
      :onBack="backClicked"
      finalStepLabel="Reserve lesson time">

      <div slot="page1" class="entry">
        <div class="dt mb-4">
          <h2>Choose your lesson date</h2>
          <span v-show="date!== ''" class="result ml-4">{{date | formatDateFull}}</span><br/>&nbsp;
        </div>

        <h4 class=" directions mb-3">1. Click on blue line below to bring up the lesson calendar. <br/>2. Select an available date and click OK.</h4>
            <v-dialog
              ref="menu"
              persistent
              v-model="menu"
              autofocus
              lazy
              full-width
              width="290px"
              :return-value.sync="date"
            >
            <v-text-field
              slot="activator"
              v-model="date"
              label="Choose lesson date"
              id="date"
              autofocus
              readonly
            ></v-text-field>
            <v-date-picker v-model="date"
              scrollable
              first-day-of-week="1"
              :allowed-dates="allowedDates">
              <v-spacer></v-spacer>
              <v-btn flat @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        <v-btn small class="mt-3" @click="$router.push('/')">Cancel</v-btn>
      </div>

       <div slot="page2" class="entry">
        <div class="dt mb-4">
          <h2>Choose your lesson time</h2>
          <span v-show="lessonTime!== ''" class="result ml-4">{{lessonTime}}</span><br/>&nbsp;
        </div>
        <h4 class="directions">Available lesson times -- Click on a time slot to choose</h4>
        <p class="hint mb-3"></p>
        <ul v-for="(time, index) in lessonTimes.weekend" :key="index">
          <span v-if="day === 5 || day === 6 " >
            <li v-if="!reservedLessonTimes.includes(time)" ><a href="#" @click="setLessonTime(time)" >{{time}}</a></li>
          </span>
        </ul>
        <ul v-for="(time, index) in lessonTimes.weekday" :key="index">
          <span v-if="day === 2 || day === 3|| day === 4 ">
            <li v-if="!reservedLessonTimes.includes(time)" ><a href="#" @click="setLessonTime(time)" >{{time}}</a></li>
          </span>
        </ul>

        <v-btn small class="mt-5" @click="$router.push('/')">Cancel</v-btn>
      </div>

      <div slot="page3" class="summary">
        <h2>Your voice lesson reservation</h2>
        <hr class="mt-2 mb-4"/>
        <p class="allResults">Date: {{date | formatDateFull}}</p>
        <p class="allResults mb-5">Time: {{lessonTime}}</p>
          <v-btn small @click="$router.push('/')">Cancel</v-btn>
      </div>

    </vue-good-wizard>
  </v-container>
</template>

<script>
import router from "../router/index"
import format from "date-fns/format"
import getDay from 'date-fns/get_day'
import addDays from 'date-fns/add_days'
import isAfter from 'date-fns/is_after'
import isBefore from 'date-fns/is_before'
export default {
  name: "LessonReserve",
  data() {
    return {
      steps: [
        {
          label: "Choose lesson date",
          slot: "page1"
        },
        {
          label: "Choose lesson time",
          slot: "page2"
        },
        {
          label: "Lesson signup summary",
          slot: "page3"
        }
      ],
      date: "",
      day: "",
      menu: false,
      lessonTime: ""
    }
  },
  computed: {
    lessonTimes() {
      return this.$store.state.lessonTimes
    },
    disallowedDates() {
      return this.$store.getters.getDisallowedDates
    },
    reservedLessonTimes() {
      let arrReservedlessonTimes = this.$store.getters.reservedLessonTimes
      if (this.date === '2018-11-25') {
        let arr = ['9:00am - 10:00am', '11:00am - 12:00pm']
        arr.forEach(el => arrReservedlessonTimes.push(el))
      }
      return arrReservedlessonTimes
    },
    user() {
      return this.$store.getters.getUser
    }
  },
  watch: {
    date() {
      this.day = getDay(new Date(this.date))
      this.$store.commit('setLessonDate', this.date)
    }
  },
  methods: {
    setLessonTime(strTime) {
      this.lessonTime = strTime
    },
    globalDates(val){
      let yesterday = addDays(new Date(), -1)
      let twoMonths = addDays(new Date(), 60)
      return (getDay(new Date(val)) === 5 || getDay(new Date(val)) === 2 || getDay(new Date(val)) === 6) 
      && isAfter(new Date(val), yesterday) && isBefore(new Date(val), twoMonths)
    },
    allowedDates(val) {
      return this.globalDates(val) && !this.disallowedDates.includes(val)
    },
    nextClicked(currentPage) {
      switch (currentPage) {
        case 0:
          if (this.date === "") {
            alert("Please choose a date")
            document.getElementById("date").focus()
            return false
          }

          let unavailable = format(this.date, 'ddd. MMMM Do YYYY')
          if (getDay(new Date(this.date)) === 5 || getDay(new Date(this.date)) === 6) {
            //is a weekend
            if (this.reservedLessonTimes.length === this.lessonTimes.weekend.length) {
              alert(`${unavailable} is no longer available. Please choose another open date!`)
              return false
            }
          } else {
            //is a weekday
            if (this.reservedLessonTimes.length === this.lessonTimes.weekday.length) {
              alert(`${unavailable} is no longer available. Please choose another open date!`)
              return false
            }
          }
          break

        case 1:
          if (this.lessonTime === "") {
            alert("Please enter a lesson time")
            return false
          }
          break

        case 2:
          const strFormattedDate = format(this.date, 'ddd. MMM. D, YYYY')

          const objData = {
            service_id: 'gmail',
            template_id: 'new_lesson',
            user_id: this.$store.state.emailJSId,
            template_params: {
              'studentName': this.user.name,
              'lessonDate': strFormattedDate,
              'lessonTime': this.lessonTime,
              'timestamp': format(new Date(), 'ddd. MMM. D, YYYY h:mm A')
            }
          }

          let objLesson = {
            studentId: this.user.userId,
            name: this.user.name,
            date: this.date,
            lessonTime: this.lessonTime,
            timestamp: this.getTimestamp(this.date, this.lessonTime)  // for display sorting
          }

          objLesson.data = objData

          let str = `You've reserved ${strFormattedDate} at ${this.lessonTime} for your next voice lesson.`
          if (confirm(str)) {
            this.$store.dispatch("addLesson", objLesson)
          }
          break

        default:
          break
      }
      return true //return false if you want to prevent moving to next page
    },
    backClicked(currentPage) {
      return false //return false if you want to prevent moving to previous page
    },
    getTimestamp(strDate, strlessonTime) {
      let time = strlessonTime.substring(0, 2)
      let strResult = ''

      switch (time) {
        case `9:`:
          strResult = `${strDate} 09:00:00`
          break;
        case "10":
          strResult = `${strDate} 10:00:00`
          break;
        case "11":
          strResult = `${strDate} 11:00:00`
          break;
        case "12":
          strResult = `${strDate} 12:00:00`
          break;
        case `1:`:
          strResult = `${strDate} 13:00:00`
          break;
        case `2:`:
          strResult = `${strDate} 14:00:00`
          break;
        case `3:`:
          strResult = `${strDate} 15:00:00`
          break;
        case `4:`:
          strResult = `${strDate} 16:00:00`
          break;
        case `5:`:
          strResult = `${strDate} 17:30:00`
          break;
        case `6:`:
          strResult = `${strDate} 18:00:00`
          break;
      }
      return new Date(strResult).getTime()
    }
  }
}
</script>

<style scoped>
.cont {
  width: 90%;
}

.directions {
  color: gray;
  font-weight: 400;
}

.dt {
  display: flex;
  align-items: baseline;
}
.entry {
  padding: 30px;
}

.result {
  color: #3d3d3d;
  font-size: 1.2rem;
  font-weight: 600;
  /* margin-bottom: 20px; */
}

.allResults {
  color: #3d3d3d;
  font-family: "Lato", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 10px;
}

.summary {
  margin: 60px;
}

ul {
  font-family: "Lato", sans-serif;
  list-style-type: none;
}

a {
  color: #3d3d3d;
}

.hint {
  font-family: "Lato", sans-serif;
  font-weight: 300;
  font-size: 1rem;
}

li {
  margin-bottom: 10px;
}
</style>